import { buildSubModuleRoute } from '@/app/arch/helpers/RouterHelper';
import GroupLimits from 'Modules/contacard/limits/groupLimits/routes';
import AntiFraud from 'Modules/contacard/limits/antiFraud/routes';

export default [
  buildSubModuleRoute({
    name: 'limits',
    moduleId: 'contacard',
    subModuleTitle: 'Antifraude',
    path: 'antifraud/',
    subModuleGroup: [
      {
        title: 'Limites',
        name: 'limits',
      },
    ],
    children: [
      ...GroupLimits,
      ...AntiFraud,
    ],
  }),
];
